<template>
  <template v-if="loading">
    <div class="card posts-scheduled px-6 py-5 custom-shadow">
      <h4 class="title">{{ $t('active_ad_accounts') }}</h4>
      <div
        v-if="accounts?.length"
        class="social-active-acount"
        v-for="(account, index) in accounts"
        :key="index"
      >
        <FacebookIcon v-if="account?.provider === 'facebook'" />

        <Insta v-if="account?.provider === 'instagram'" />

        <SnapIcon v-if="account?.provider === 'snapchat'" />

        <TiktokIcon v-if="account?.provider === 'tiktok'" />

        <p>
          {{
            account?.account_name.toLowerCase().charAt(0).toUpperCase() +
            account?.account_name.toLowerCase().slice(1)
          }}
        </p>
      </div>
      <div v-else class="mt-4">
        <img
          src="@/components/icons/activeadicons/no-account.png"
          alt="no-accounts"
        />
        <p class="mt-2">There Is No Accounts</p>
      </div>
    </div>
  </template>
  <template v-else>
    <v-skeleton-loader
      v-for="n in 3"
      :key="n"
      type="list-item-avatar, list-item-two-line"
      class="mb-4"
    />
  </template>
</template>
<script>
import Addaccount from "@/components/icons/activeadicons/Addaccount.vue";
import Insta from "@/components/icons/activeadicons/InstaIcon.vue";
import FacebookIcon from "@/components/icons/activeadicons/FacebookIcon.vue";
import TiktokIcon from "@/components/icons/activeadicons/TiktokIcon.vue";
import SnapIcon from "@/components/icons/activeadicons/SnapIcon.vue";
export default {
  name: "ActiveAdAccounts",
  props: {
    accounts: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: { Addaccount, Insta, FacebookIcon, TiktokIcon, SnapIcon },
};
</script>
<style scoped>
.custom-shadow {
  box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.08);
}
.post-shadow {
  box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.08), 0px 0px 12px rgba(0, 0, 0, 0.08);
}
.card {
  height: 100%;
}
.active-ad-acount .card .social-active-acount {
  box-shadow: none;
}
.social-active-acount p {
  color: #666666;
  font-family: "Inter", sans-serif;
  text-transform: capitalize;
}
.active-ad-acount .card .add-new-account {
  background-color: #fff;
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 7px 15px;
  border-radius: 12px;
  box-shadow: none;
  border: 2px dashed #2e989e;
  margin-bottom: 15px;
  cursor: pointer;
  width: 100%;
}
.active-ad-acount .card .add-new-account button {
  margin: 0;
  padding: 0;
  height: max-content;
}
.active-ad-acount .card .add-new-account button:hover {
  background-color: transparent;
}
.active-ad-acount .card .add-new-account button img {
  width: 1.5rem;
  height: 1.5rem;
}
.addbb {
  border: 2px solid #237276;
  display: flex;
  padding: 0.3rem !important;
  border-radius: 0.5rem;
}
</style>
